<template>
  <main-layout>
    <v-overlay
      :absolute="false"
      :opacity="0.9"
      :value="overlay"
      :z-index="5"
    >
      <v-container v-if="selectedAlbum != undefined" fluid height="95vh" style="width:100vw">
        <v-row no-gutters justify="center">
          <v-btn color="primary" class="mb-3">
            {{ selectedAlbum.name }} - {{ selectedAlbum.photos.length }} pictures
          </v-btn>
          <v-btn color="primary" fab @click="overlay = false" class="float-right" style="position: absolute; right: 10px" x-small>
            <v-icon>close</v-icon>
          </v-btn>
        </v-row>
        <v-row no-gutters>
          <v-col id="PicCarroussel" cols="12" md="9" class="overflow-y-auto" style="height: 90vh" justify="center">
            <v-img
              v-for="photo in selectedAlbum.photos"
              :key="photo"
              :contain="true" 
              :src="picPath + photo"
              max-height="100%"
              max-width="100%"
              class="mb-5"
              tile>
            </v-img>
            <v-btn color="primary" fab @click="overlay = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12" md="3" class="overflow-y-auto d-none d-md-block" style="height: 90vh" justify="center">
            <v-img
              v-for="a in albums"
              :key="a.name"
              :contain="true"
              :src="picPath + a.photos[0]"
              max-height="100%"
              max-width="100%"
              :class="'picture mb-5 ' + (a.name == selectedAlbum.name ? 'picture_active' : '')"
              @click="openAlbum(a)">
              <div class="picture-label">{{ a.name }}</div>
            </v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>
    <v-layout wrap class="d-flex">
      <v-flex xs12 class="center-center">
        <v-card
          elevation="32"
          :raised="true"
          class="text-justify mb-4">
          <v-card-title>Photography</v-card-title>
          <v-card-text class="text-left">
            <p>I've picked up photography about 7 years ago as a hobby, and a replacement from acting as I started traveling too much. Experimenting first with lights, I have turned to humanist photography over the course of my world trips. As pictures that testify of day-to-day life.</p>
            <p>If there is key understanding I’ve gained through traveling, is that no matter how different our social customs are, humans are identical at their core. I believe documenting these key cultural differences only reflect how similar we are, and I try to do so as genuinely as possible.</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex v-for="i in [0, 1, 2]" xs12 md6 lg4 :key="'col-' + i" class="pt-0 pb-0">
        <v-img :contain="true" v-for="a in albums.filter(a => a.col == i)" :key="a.name" :src="picPath + a.photos[0]" :class="$vuetify.breakpoint.xsOnly ? 'picture_xs' : 'picture'" @click="openAlbum(a)">
          <div class="picture-label">{{ a.name }}</div>
        </v-img>
      </v-flex>
    </v-layout>
  </main-layout>
</template>

<script>
  import MainLayout from '../layouts/Main.vue'
  import goTo from 'vuetify/es5/services/goto'
  const pics_files = require.context('../../public/photographer/', true)

  var albums = {}
  pics_files.keys().forEach( file => {
    var pattern = /^\.\/([^\/]+)\/.*$/
    var folder = pattern.exec(file)
    if (folder) {
      if (albums[folder[1]] == undefined) albums[folder[1]] = []

      albums[folder[1]].push(file)
    }
  });

  console.log('Loaded albums: ' + Object.keys(albums).join(','))

  export default {
    name: 'Photographer',
    components: {
      MainLayout
    },
    data: () => ({
      picPath: process.env.BASE_URL + 'photographer/',
      overlay: false,
      albums: [
        {
          name: 'Sarajevo',
          desc: '',
          photos: albums['sarajevo'] || [],
          col: 0
        },
        {
          name: 'Dhavari, Mumbai',
          desc: '',
          photos: albums['dhavari'] || [],
          col: 1
        },
        {
          name: 'Venice Beach, LA',
          desc: '',
          photos: albums['los_angeles'] || [],
          col: 2
        },
        {
          name: 'Bucharesti, Romania',
          desc: '',
          photos: albums['bucharesti'] || [],
          col: 0
        },
        {
          name: 'Hong-Kong',
          desc: '',
          photos: albums['hongkong'] || [],
          col: 1
        },
        {
          name: 'Sibiu, Romania',
          desc: '',
          photos: albums['sibiu'] || [],
          col: 2
        }
      ],
      selectedAlbum: undefined,
    }),
    methods: {
      openAlbum: function(album) {
        if (this.selectedAlbum != undefined && this.overlay == true)
          goTo(0, {container: '#PicCarroussel'});

        this.selectedAlbum = album
        this.overlay = true
      }
    },
  }
</script>

<style>
  .picture-label {
    width: 100%;
    color: white;
    background: #12579b99;
    margin: 0px;
    padding: 5px;
    padding-left: 10px;
    text-align: left;
    position: absolute;
    bottom: .5em;
    font-size: 1.5em;
    font-weight: 400;

    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
    left: 0;
  }

  .picture .v-image__image {
    opacity: 0.5;
  }

  .picture:hover .v-image__image,
  .picture_active .v-image__image,
  .picture_xs .v-image__image {
    opacity: 1;
  }
</style>